import { jsx as _jsx } from "react/jsx-runtime";
export function Backdrop({ children, closeOnBackdrop, onDismiss, }) {
    return (_jsx("div", { className: "\n\t\t\t\tpointer-events-auto\n\t\t\t\tfixed\n\t\t\t\tinset-0\n\t\t\t\tflex\n\t\t\t\titems-center\n\t\t\t\tjustify-center\n\t\t\t\toverflow-y-auto\n\t\t\t\tbg-black/40\n\t\t\t\tp-4\n\t\t\t", onPointerDown: event => {
            /*
             * Only dismiss when the backdrop itself was
             * pressed, not when an event bubbled from the
             * actual dialog.
             */
            if (closeOnBackdrop
                && event.target
                    === event.currentTarget) {
                onDismiss();
            }
        }, children: children }));
}
//# sourceMappingURL=Backdrop.js.map